// Leadres Block Mixin for leaders block
// at home and landings pages
var MpLeadersBlock = {

    data: function() {
        return {
            categories: [],
            leaders: [],
            leadersCategory: null,
            leadersHighlightIndex: -1,
        };
    },

    computed: {

        leaderHighlight: function() {
            return (this.leadersHighlightIndex>0) ? this.leaders[this.leadersHighlightIndex] : null;
        },
    },

    methods: {

        removeEmptyCategories: function() {
            let categoryNodes = this.$refs.leadersFilter.querySelectorAll('.js-leader-category');

            categoryNodes.forEach(c => {
                let hasEquipments = this.leaders.reduce((previous, current) => {
                    return previous || (current.categories.indexOf(parseInt(c.getAttribute('id'))) >= 0);
                }, false);

                if (!hasEquipments) {
                    c.remove();
                }
            });
        },

        initLeadersPanel: function() {

                this.$refs.ssrLeadersList.querySelectorAll('.js-leader').forEach(leader => {
                    this.leaders.push({
                        id: leader.dataset.id,
                        company: leader.dataset.company,
                        logo: leader.dataset.logo,
                        resume: leader.dataset.resume,
                        category: leader.dataset.category,
                        categories: JSON.parse('['+leader.dataset.categories+']'),
                        order: parseInt(leader.dataset.order),
                        link: leader.dataset.link,
                        web: leader.dataset.web,
                        shareUrl: leader.dataset.sharehref,
                        shareTitle: leader.dataset.sharetitle,
                        visible: true,
                    });
                });

                this.removeEmptyCategories();
                this.filterLeadersPanel('');
            },

            getCategoryHighlightIndex: function() {
                var min = 999;
                return this.leaders.reduce((previous, current, index) => {
                    if (!current.visible || ![0, 1].includes(current.order)) {
                        return previous;
                    }

                    if (current.order < min) {
                        min = current.order;
                        return index;
                    }

                    return previous;
                }, -1);
            },

            filterLeadersPanel: function(category) {
                if (category === this.leadersCategory) {
                    return;
                }

                this.leadersCategory = category;
                this.leaders.forEach(leader => {
                    leader.visible = !this.leadersCategory || (leader.categories.indexOf(parseInt(this.leadersCategory)) >= 0);
                });
                this.leadersHighlightIndex = this.getCategoryHighlightIndex();
            }
    },

    filters: {},

    created: function () {},

    mounted: function() {},

    updated: function() {}
};